/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductListBarcodeItem
 */
export interface ProductListBarcodeItem {
    /**
     * 条码主键ID
     * @type {number}
     * @memberof ProductListBarcodeItem
     */
    id?: number;
    /**
     * 平台条码
     * @type {string}
     * @memberof ProductListBarcodeItem
     */
    marketBarcode?: string;
    /**
     * 平台商品名称
     * @type {string}
     * @memberof ProductListBarcodeItem
     */
    marketProductName?: string;
    /**
     * 平台选项名称
     * @type {string}
     * @memberof ProductListBarcodeItem
     */
    marketOptionName?: string;
    /**
     * 平台选项ID
     * @type {string}
     * @memberof ProductListBarcodeItem
     */
    marketOptionId?: string;
    /**
     * 第三方电商平台ID
     * @type {number}
     * @memberof ProductListBarcodeItem
     */
    businessPlatformId?: number;
    /**
     * 第三方电商平台名称
     * @type {string}
     * @memberof ProductListBarcodeItem
     */
    businessPlatformName?: string;
}

/**
 * Check if a given object implements the ProductListBarcodeItem interface.
 */
export function instanceOfProductListBarcodeItem(value: object): value is ProductListBarcodeItem {
    return true;
}

export function ProductListBarcodeItemFromJSON(json: any): ProductListBarcodeItem {
    return ProductListBarcodeItemFromJSONTyped(json, false);
}

export function ProductListBarcodeItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListBarcodeItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProductName': json['marketProductName'] == null ? undefined : json['marketProductName'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'businessPlatformId': json['businessPlatformId'] == null ? undefined : json['businessPlatformId'],
        'businessPlatformName': json['businessPlatformName'] == null ? undefined : json['businessPlatformName'],
    };
}

export function ProductListBarcodeItemToJSON(json: any): ProductListBarcodeItem {
    return ProductListBarcodeItemToJSONTyped(json, false);
}

export function ProductListBarcodeItemToJSONTyped(value?: ProductListBarcodeItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'marketBarcode': value['marketBarcode'],
        'marketProductName': value['marketProductName'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'businessPlatformId': value['businessPlatformId'],
        'businessPlatformName': value['businessPlatformName'],
    };
}

